// import _ from 'lodash';

const orderTemplate = {
  loading: true,
  fullRangeLoading: true,
  list: {},
  fullRange: {},
  nullFilteredOrderTemplate: false,
  coreValue: 0,
}
const OrderTemplateReducer = function (state = orderTemplate, action) {
  switch (action.type) {
    case 'TOGGLE_FULL_RANGE_LOADING': {
      return {
        ...state,
        fullRangeLoading: action.value,
      }
    }
    case 'TOGGLE_ORDER_TEMPLATE_LOADING': {
      return {
        ...state,
        loading: action.value,
      }
    }
    case 'TOGGLE_ORDER_TEMPLATE_COREVALUE': {
      console.log(action.value, 'CoreValue')
      return {
        ...state,
        coreValue: action.value + 1,
      }
    }
    case 'SET_ORDER_TEMPLATE': {
      return {
        ...state,
        list: action.list,
      }
    }
    case 'SET_FULL_RANGE': {
      return {
        ...state,
        fullRange: action.list,
      }
    }
    case 'UPDATE_FULL_RANGE': {
      let newList = {}
      Object.entries(action.list).forEach(([key, value]) => (newList[key] = { ...state.fullRange[key], ...value }))
      return {
        ...state,
        fullRange: {
          ...state.fullRange,
          ...newList,
        },
      }
    }
    case 'UPDATE_ORDER_TEMPLATE': {
      let newList = {}
      Object.entries(action.list).forEach(([key, value]) => (newList[key] = { ...state.list[key], ...value }))
      return {
        ...state,
        list: {
          ...state.list,
          ...newList,
        },
      }
    }
    case 'FILTER_ORDER_TEMPLATE': {
      return {
        ...state,
        list: action.list,
      }
    }
    case 'REMOVE_ORDER_TEMPLATE': {
      return {
        ...state,
        list: Object.entries(action.list).reduce((accumulator, [key, value]) => {
          const { [key]: removedItem, ...rest } = accumulator
          // console.log('Removed item', removedItem);
          return rest
        }, state.list),
      }
    }
    case 'SET_NULL_FILTERED_ORDER_TEMPLATE': {
      return {
        ...state,
        nullFilteredOrderTemplate: action.value,
      }
    }
    default: {
      return state
    }
  }
}

export default OrderTemplateReducer
